import { existy } from '../../utils';

export default function load({ url, success, responseType, rangeStart, rangeEnd, error }) {
   const xhr = createXHR(() => {
      const data = xhr.responseType === 'arraybuffer' ? xhr.response : xhr.responseText;
      success({ url: xhr.responseURL, data });
   }, error);

   xhr.open('GET', url, true);

   if ( existy(rangeEnd) && existy(rangeStart) ) {
      xhr.setRequestHeader('Range', 'bytes=' + rangeStart + '-' + --rangeEnd);
   }

   if ( existy(responseType) ) {
      xhr.responseType = responseType;
   }
   xhr.send(null);
}

function createXHR(callback, error) {
   if (typeof XDomainRequest === 'undefined') {
      const xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function onreadystatechange() {
         try {
            if (xhr.readyState === 4) {
               if (xhr.status === 200) {
                  setTimeout(callback);
               } else if (error && (!xhr.status || xhr.status >= 400)) {
                  setTimeout(error);
               }
            }
         } catch (e) {
            // noop
         }
      };
      return xhr;
   }

   const xdr = new XDomainRequest();
   xdr.onload = callback;
   return xdr;
}
